const nnTranslations = {
    confirmationScreen: {
        consumerLoanTitle: 'Forbrukslån',
        refinancingTitle: 'Refinansiering',
        creditCardTitle: 'Våre kredittkort',
        title: 'Berekn pris og søk',
        description: '{} vert levert av Kredittbanken. For at Kredittbanken enkelt skal behandla søknaden din, delar vi opplysningar om deg medan du søkjer.',
        toggleButtonText: 'Kva opplysningar vert delte?',
        listTitle: 'Du deler:',
        phone: 'telefonnummer',
        email: 'e-post',
        fnr: 'fødselsnummer',
        customerRelationship: 'stadfesting på at du er bankkunde hos oss',
        loanLinkText: 'Berekn pris og søk',
        creditCardLinkText: 'Søk om kredittkort',
        eikaEmployeeCardLinkText: 'Søk om bedriftskort',
    },
    errors: {
        somethingWentWrong: 'Noko gjekk galt!',
        defaultMessage: 'Orsak, det oppstod ein teknisk feil. Ver vennleg og prøv igjen om ei tid.',
        errorCodeHeader: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        informationModalTitle: 'Kva kan eg bruka feilkoden til?',
        informationModalDescription: 'Når det oppstår ein feil, hender det ein blir nøydde til å kontakta banken for å få hjelp. Då er det veldig nyttig å ha ein feilkode banken kan få, så me lettare kan sjå kva som er gått gale. \n' +
            '\n' +
            'Ta eit skjermbilete av feilmeldinga eller les opp feilkoden til personen du pratar med på telefon. Skriv du med oss via meldingar i mobil- eller nettbank? Då kan du enkelt klikka «Kopier feilkode», for deretter å lima han inn i meldingsvindauget til den banktilsette du skriv med.\n' +
            '\n' +
            'Saman finn me ut av kva som har gått gale. Lykke til!',
    },
    goBack: 'Gå tilbake',
    nominalInterest: 'Nominell rente {}%',
    loanListTitle: 'Andre lån',
    loanOwners: {
        title: 'Låntakarar',
        accountRole: {
            DEBTOR: 'Eigar av lån',
            CO_DEBTOR: 'Medlåntakar',
            GUARANTOR: 'Kausjonist',
            UNKNOWN: 'Ukjent',
        },
    },
    loanDetails: {
        title: 'Detaljar',
        name: 'Namn på lån',
        intialAmount: 'Opphavleg lånebeløp',
        maturityDate: 'Nedbetalingsdato',
        effectiveInterest: 'Effektiv rente',
        paymentDate: 'Forfallsdato',
        paymentDay: '{}. kvar månad',
        instalmentAmount: 'Terminbeløp',
    },
    loanInterest: {
        nominalInterest: 'Nominell rente',
        effectiveInterest: 'Effektiv rente {}%',
        loanRepaymentLinkTitle: 'Sjå nedbetalingsplan',
        loanRepaymentLinkDescription: 'Hos Kredittbanken',
    },
    loanOverview: {
        accountName: 'Kontonamn',
        accountNumber: 'Kontonummer',
        disposible: 'Disponibelt',
        moneyOnTheWay: 'Pengane er på veg. Det kan ta nokre verkedagar før pengane er utbetalte.',
        interest: 'Nominell rente',
        paymentDueDate: 'Neste innbetaling',
        instalmentAmount: 'Beløp',
        extraPayment: 'Ekstra innbetaling',
        more: 'Meir',
        changeDate: 'Endre forfall',
        seeDocuments: 'Sjå faktura og dokument',
        atKredittbanken: 'Hos Kredittbanken',
        infoKredittbankne: 'Våre forbrukslån og kredittkort vert leverte av Kredittbanken',
        showLoanAtKredittbanken: 'Sjå lånet ditt hos Kredittbanken',
        loanPayedDown: 'Lånet er nedbetalt',
    },
    transactions: {
        noTransactions: 'Her har det ikkje skjedd stort!',
        noMoreTransactionsToLoad: 'Det var alle transaksjonane på denne kontoen',
        reserved: 'Reservert',
        couldNotLoadMoreTransactions: 'Orsak, grunna teknisk svikt klarte vi ikkje å laste fleire transaksjonar. Prøv igjen om ei tid.',
        tryAgain: 'Prøv om att',
    },
    creditCardScreen: {
        infoTitle: 'Du har allereie eit kredittkort hos oss',
        infoText: 'Du kan søkja om kredittgrense opp til 100 000 kr, eller søkja om eit nytt kredittkort',
        cardListTitle: 'Øk kredittgrense',
        creditLimitText: 'Kredittgrensa di er {} kr',
        applyForCreditCardTitle: 'Søk om kredittkort',
        applyForEikaEmployeeTitle: 'Søk om bedriftskort',
        applyForEikaEmployeeCardText: 'For deg som ønskjer å skilja jobbrelaterte utgifter frå privatøkonomien',
        blockedCreditLimit: 'Du kan ikkje søkja om auka kredittgrense på dette kortet',
        creditCardLimitErrorTitle: 'Du kan ikkje søkja om auka kredittgrense akkurat no',
        creditCardLimitErrorText: 'Det kan vera fleire grunnar til det. Prøv igjen seinare eller kontakt kundeservice om du treng hjelp.',
        buttonOk: 'Ok',
    },
    refinancingCalculator: {
        estimateTitle: 'Sjekk kor mykje du kan spara',
        monthlyPayment: 'Månadleg kostnad',
        estimatedSavings: 'Total mogleg innsparing',
        buttonSearchHousingLoan: 'Gå til søknad',
        nominalInterest: 'Nominell rente ',
        interestRateMinMax: 'Frå {} til {} %',
        wishedLoanAmount: 'Ønskt lånebeløp',
        loanAmountMinMax: 'Frå {} til {}',
        effectiveInterestRate: 'Effektiv rente',
        paymentTimeMinMax: 'Frå {} til {} år',
        downPaymentTime: 'Nedbetalingstid',
        estimateText: 'Basert på gjennomsnittleg innsparing for kundar som har refinansiert hos Kredittbanken ASA.',
        priceExample: 'Døme:',
        priceExampleText: '{} {} kr over {} år, nominell rente {} %, effektiv rente {} %. Totalt beløp å betala: {} kr. Kostnad: {} kr.',
        contactAdvisor: 'Kontakt rådgjevar',
        aboutRefinancing: 'Om refinansiering',
        tryAgain: 'Prøv igjen',
        errorMessage: 'Vi beklagar, men noko gjekk gale',
        loanAmountError: 'Beløpet er for lågt eller høgt',
        termYearsError: 'Renta er for låg eller høg',
        interestRateError: 'Nedbetalingstid er for lang',
    },
};
export default nnTranslations;
//# sourceMappingURL=data:application/json;base64,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